// Service para las dos puertas de bajada del backend offline-first (Fase 2):
//   GET /api/sync/catalogs  -> catalogos (categorias, rodeos, lotes, tipos de
//                              tratamiento, roles, permisos) para trabajar offline
//   GET /api/sync/snapshot  -> foto del establecimiento (animales activos +
//                              eventos recientes de los ultimos 60 dias)
//
// Sigue el patron de los demas services Java (pesajesback.js, animalesback.js):
// RUTA_JAVA segun env, token via getUser(), y handleAuthenticatedRequest (que
// dispara session-expired solo en 401/403; un error de red offline se re-lanza
// tal cual para que TanStack Query sirva el cache).
//
// El establecimiento lo scopea el JWT en el backend: NO se manda establishmentId.
// El parametro ?since se omite (hoy el backend devuelve full snapshot e ignora
// since; ver decision de Fase 2).
import { getUser } from "$lib/userstorage/usersotrage";
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback";

let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD == "si";
let RUTA_JAVA = bd_local ? ruta_local_java : ruta_java;

const RUTA_SYNC = "sync";

// `token` opcional: si se pasa, se usa ese access (scoped a un establecimiento
// que NO es el activo, para drenar/pre-cachear multi-establecimiento). Si no, el
// token de la sesión activa.
function authOptions(token) {
    const t = token ?? getUser().token;
    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${t}`,
        },
    };
}

export async function fetchCatalogs(token) {
    let url = `${RUTA_JAVA}${RUTA_SYNC}/catalogs`;
    let res = await handleAuthenticatedRequest(url, authOptions(token));
    return jsonOrThrow(res, "sync.fetchCatalogs");
}

export async function fetchSnapshot(token) {
    let url = `${RUTA_JAVA}${RUTA_SYNC}/snapshot`;
    let res = await handleAuthenticatedRequest(url, authOptions(token));
    return jsonOrThrow(res, "sync.fetchSnapshot");
}

// Drena un lote de escrituras offline contra POST /api/sync/batch (Paso 6).
// `operations` = [{ clientUuid, entity, operation, payload }].
// El endpoint SIEMPRE responde 200 (los rechazos por operacion vienen como
// status "conflict"/"error" en cada result). Devuelve { results: [...] } con
// { clientUuid, status: "ok"|"conflict"|"error", serverId, errorCode, errorMessage }.
// El establecimiento lo scopea el JWT; no se manda establishmentId.
export async function batchSync(operations, token) {
    let url = `${RUTA_JAVA}${RUTA_SYNC}/batch`;
    let options = {
        ...authOptions(token),
        method: "POST",
        body: JSON.stringify({ operations }),
    };
    let res = await handleAuthenticatedRequest(url, options);
    return jsonOrThrow(res, "batchSync");
}
